import {SET_BUTTONS} from '../actions';
import { reduxStoreTypes } from '@type/redux-store';

const buttons = (buttons: string[] = [], action: reduxStoreTypes.ButtonAction) => {
    if (action.type === SET_BUTTONS) {
        return action.buttons
    }
    return buttons
}
export default buttons